<template>
  <b-list-group class="schedule-posts-times-picker">
    <b-list-group-item v-for="day in Object.keys(labels)" :key="day" class="d-flex flex-row align-items-center">
      <b-form-checkbox :id="`select-${day}`" class="py-2" switch
        :checked="Array.isArray(times[day])" @change="() => toggleDay(day)">
        {{ labels[day] }}
      </b-form-checkbox>
      <template v-if="Array.isArray(times[day])">
        <b-form-select v-for="(time, i) in times[day]" :key="`${day}-${i}`" class="w-auto mx-2"
          :value="time" @input="time => chooseTime(day, i, time)" :options="selectTimesOpts"/>
        <b-btn v-if="times[day].length < 2" @click="() => addTimeSlot(day)" variant="transparent">+ Add another time</b-btn>
      </template>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    times: null,
  }),
  created() {
    this.times = {};
    [ 'mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun' ].forEach(key => {
      this.times[key] = this.value && Array.isArray(this.value[key]) ? this.value[key] : undefined;
    });
  },
  computed: {
    labels: () => ({
      mon: 'Monday',
      tue: 'Tuesday',
      wed: 'Wednesday',
      thu: 'Thursday',
      fri: 'Friday',
      sat: 'Saturday',
      sun: 'Sunday',
    }),
    selectTimesOpts() {
      const times = [ { text: '--', value: null } ];

      let count = 0;
      while (count <= (1440 - 30)) {
        const rem = count % 60;
        const hour = (((count - rem) / 60) % 12) || 12;
        const minute = rem || '00';
        const suffix = count < 720 ? 'AM' : 'PM';
        times.push({ text: `${hour}:${minute} ${suffix}`, value: count });
        count += 30;
      }

      return times;
    },
  },
  methods: {
    toggleDay(day) {
      this.$set(this.times, day, Array.isArray(this.times[day]) ? undefined : [ null ]);
      this.$forceUpdate();
    },
    addTimeSlot(day) {
      this.times[day].push(null);
      this.$forceUpdate();
    },
    chooseTime(day, i, time) {
      this.times[day][i] = time;
      this.$emit('input', cleanTimes.call(this));
    },
  },
};

function cleanTimes() {
  const data = {};

  for (const day in this.times) {
    if (this.times.hasOwnProperty(day) && Array.isArray(this.times[day])) {
      const chosenTimes = this.times[day].filter(value => typeof value === 'number');
      if (chosenTimes.length) {
        data[day] = chosenTimes;
      }
    }
  }

  return data;
}
</script>



// WEBPACK FOOTER //
// src/components/users/ScheduledPostTimesPicker.vue